<template>
  <div class="circuit-breaker-bid">
    <p
      class="subtitle is-4 has-text-left"
      style="padding-top: 15px; margin-bottom: 2px"
    >
      <span style="padding-left: 70px">Circuit-Breaker Delivery</span>
    </p>

    <div class="container">
      <div class="notification">
        <div style="padding-bottom: 6px">
          <label class="label has-text-link">Job Details</label>
        </div>

        <!-- pickup -->
        <div class="field has-addons order" @click="lookupAddress(pickup)">
          <div class="control">
            <a class="button is-outlined field-name">Pickup</a>
          </div>
          <div class="control">
            <a class="button">{{ pickup }}</a>
          </div>
          <div class="control">
            <a
              class="button has-text-weight-medium is-outlined"
              style="width: 35px"
            >
              <i class="fa fa-map-marker-alt" />
            </a>
            👈🏼Click
          </div>
        </div>

        <!-- dropoff -->
        <div class="field has-addons order" @click="lookupAddress(dropoff)">
          <div class="control">
            <a class="button is-outlined field-name">Dropoff</a>
          </div>
          <div class="control">
            <a class="button">{{ dropoff }}</a>
          </div>
          <div class="control">
            <a
              class="button has-text-weight-medium is-outlined"
              style="width: 35px"
            >
              <i class="fa fa-map-marker-alt" />
            </a>
            👈🏼Click
          </div>
        </div>

        <!-- time -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined field-name">
              <i class="far fa-clock" />&nbsp;Time
            </a>
          </div>
          <div class="control">
            <a class="button">{{ time }}</a>
          </div>
        </div>

        <!-- offer -->
        <div class="field has-addons order">
          <div class="control">
            <a class="button is-outlined field-name">
              <i class="fa fa-dollar-sign" />&nbsp;Offer
            </a>
          </div>
          <div class="control">
            <a class="button">{{ offer }}</a>
          </div>
        </div>

        <div class="field is-grouped">
          <p class="control">
            <button class="button is-success" @click="acceptOffer">
              Accept Offer
            </button>
          </p>
          <p class="control">
            <button class="button is-primary" @click="makeBid">
              Make a Bid
            </button>
          </p>
          <p class="control">
            <button class="button is-info" @click="shareOffer">
              <i class="fa fa-share-alt" />&nbsp;Share
            </button>
          </p>
        </div>
        <!-- <br /> -->

        <div v-if="collectInfoType && !completed">
          <div style="padding-bottom: 6px">
            <label class="label has-text-link">Please Enter Your Details</label>
          </div>
          <div class="field has-addons order">
            <div class="control">
              <a class="button is-outlined">
                <i class="fa fa-phone" />
              </a>
            </div>
            <div class="control is-expanded">
              <input
                class="input is-info"
                v-model="yourNumber"
                type="number"
                placeholder="Your WhatsApp Number"
              />
            </div>
          </div>

          <div v-if="collectInfoType === 'accept'">
            <div class="field">
              <div class="control">
                <button
                  class="button is-link is-fullwidth"
                  :disabled="!this.yourNumber"
                  @click="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>

          <div v-else>
            <!-- bid -->
            <div class="field has-addons order">
              <div class="control">
                <a class="button is-outlined field-name">
                  <i class="fa fa-dollar-sign" />&nbsp;Bid
                </a>
              </div>
              <div class="control is-expanded">
                <input
                  class="input is-info"
                  v-model="bid"
                  type="number"
                  placeholder="Your Bid"
                />
              </div>
            </div>

            <div class="field">
              <div class="control">
                <button
                  class="button is-link is-fullwidth"
                  :disabled="!this.yourNumber"
                  @click="submit"
                >
                  Submit Bid
                </button>
              </div>
            </div>
          </div>
        </div>
        <p
          class="title is-5 has-text-danger"
          style="padding-top: 15px"
          v-if="completed"
        >
          🦜 Bid Submitted 🙌🏽
          <br />
          <span class="subtitle is-6">Please Submit Only Once</span>
        </p>

        <!-- <div class="field"> -->
        <!-- <div class="control"> -->
        <div
          class="button tag is-outlined has-text-link is-fullwidth is-medium"
          style="margin-top: 10px"
          @click="seeBids"
        >
          <i class="fa fa-spinner fa-spin" />&nbsp;Available job with 4 bids
        </div>
        <div v-for="i in 4" :key="i">
          <div
            class="button tag is-outlined has-text-link is-fullwidth is-medium"
            style="margin-top: 10px"
            @click="seeBids"
          >
            <span class="blurry">####4601 bid $13</span>
          </div>
        </div>
        <div
          class="button tag is-info is-fullwidth is-medium"
          style="margin-top: 10px"
          @click="seeBids"
        >
          See more available jobs&nbsp;
          <i class="fa fa-chevron-right" />
        </div>
        <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CircuitBreakerBid",
  components: {},
  data() {
    return {
      phoneNumber: null,
      pickup: null,
      dropoff: null,
      time: null,
      offer: null,
      collectInfoType: null,
      yourNumber: null,
      bid: null,
      completed: false,
    };
  },
  mounted() {
    this.phoneNumber = this.$route.params.id; // required parameter
    var query = this.$route.query;
    this.createdBy = query.created_by; // to send push notification back to creator
    this.offer = query.offer;
    this.time = query.time;
    this.pickup = query.p_postcode;
    this.dropoff = query.d_postcode;
  },
  methods: {
    acceptOffer() {
      this.collectInfoType = "accept";
    },
    makeBid() {
      this.collectInfoType = "bid";
    },
    invalidPhone() {
      if (this.yourNumber.length === 8) return false;
      var txt = `Invalid Phone Number!<br><br>Please enter an 8-digit Singaporean WhatsApp Number`;
      this.warningAlert(txt);
      return true;
    },
    submit() {
      if (this.collectInfoType === "bid" && !this.bid) {
        this.warningAlert("Please enter a bid or accept the offer");
        return;
      }
      if (this.invalidPhone()) return;
      this.$swal({
        type: "success",
        title: "Thank You !! 🙏🏽",
        text: `You will be contacted shortly if you won the job or if there are any questions about your bid. 👍🏼`,
      });
      this.notifyBusiness();
      this.completed = true;
    },
    shareOffer() {
      alert("Share offer...");
    },
    notifyBusiness() {
      var amount = this.bid || this.offer;
      var msg = `${this.yourNumber} submitted a bid of $${amount}`;
      this.sendPushNotification(msg, this.createdBy);
      this.sendSMS(msg, this.phoneNumber);
    },
    seeBids() {
      //   this.warningAlert("Submit your bid to see the other bids.");
      this.goHome();
    },
    lookupAddress(txt) {
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("onemapAddress", txt)
        .then((res) => {
          console.log("onemapAddress", res.data);
          if (res.data.found < 1) {
            alert(`No onemap address results for [ ${txt} ]`);
            return;
          }
          var address = res.data.results[0]; // first result
          this.$swal({
            title: txt,
            html: `<div style="text-align:left">
            Address:<br><strong>${address.ADDRESS}</strong><br><br>
            Street:<br><strong>${address.ROAD_NAME}</strong>
            </div>`,
          });
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 1rem;
}
.field-name {
  width: 100px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
.blurry {
  color: transparent;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.9);
}
</style>